var $5bef37433078ced1$exports = {};
$5bef37433078ced1$exports = {
    "close": `Luk`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} besked`,
            other: ()=>`${formatter.number(args.count)} beskeder`
        })}.`
};


export {$5bef37433078ced1$exports as default};
//# sourceMappingURL=da-DK.mjs.map
